import { SubcategoryIdEnum } from 'api/gen'

export const FREE_OFFER_CATEGORIES_TO_ARCHIVE: SubcategoryIdEnum[] = [
  SubcategoryIdEnum.CARTE_MUSEE,
  SubcategoryIdEnum.ABO_BIBLIOTHEQUE,
  SubcategoryIdEnum.ABO_MEDIATHEQUE,
]
